import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatColors } from '../../../../../core/matColors';
import { Voucher } from '../../../../../core/services/vouchers/voucher.model';
import { VOUCHER_GENERATION_MODE, VOUCHER_COMPUTE_MODE } from '../../../../../core/services/vouchers/vouchers.constants';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../../environments/environment';
import { Product } from '../../product/product.model';

@Component({
    selector     : 'fuse-voucher-form-dialog',
    templateUrl  : './voucher-form.component.html',
    styleUrls    : ['./voucher-form.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class VoucherFormDialogComponent implements OnInit
{
    voucher: Voucher;
    dialogTitle: string;
    eventForm: FormGroup;
    action: string;
    presetColors = MatColors.presets;
    minDate = new Date();
    modes = Object.values(VOUCHER_GENERATION_MODE);
    methods = Object.values(VOUCHER_COMPUTE_MODE);
    productList: Product[] = [];
    methodGeneration: string = '';

    constructor(
        public readonly dialogRef: MatDialogRef<VoucherFormDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private readonly data: any,
        // private readonly formBuilder: FormBuilder,

        private readonly http: HttpClient,
    )
    {
        this.voucher = data.voucher as Voucher;
        this.action = data.action;

        if ( this.action === 'edit' )
        {
            this.dialogTitle = `Bon "${this.voucher.code}"`;
            this.methodGeneration = this.voucher.method;
        }
        else
        {
            this.dialogTitle = 'Nouveau bon de réduction';
            this.voucher = new Voucher();
        }

        this.http.get<Product[]>(`${environment.apiUrl}/products`)
                .subscribe((response) => {
                    this.productList = response;
                });

        this.eventForm = this.createEventForm();
    }

    ngOnInit()
    {
        if ( this.action === 'edit' ) {
            this.eventForm.get('mode').disable();
            this.eventForm.get('mode').clearValidators();
            this.eventForm.get('mode').updateValueAndValidity();
            this.eventForm.get('method').updateValueAndValidity();
            // this.eventForm.updateValueAndValidity();
        }
        this.eventForm.valueChanges.subscribe(
            (d) => {
                if (d.mode === VOUCHER_GENERATION_MODE.MANUAL) {
                    this.eventForm.get('code').setValidators([Validators.required])
                } else {
                    this.eventForm.get('code').clearValidators();
                }
                // this.eventForm.get('code').updateValueAndValidity();
                this.methodGeneration = this.eventForm.get('method').value;
                // console.log(d);
                // console.log(this.eventForm.invalid)
            }
        )
    }

    createEventForm()
    {
        return new FormGroup({
            // _id             : new FormControl(this.voucher._id),
            mode            : new FormControl(this.voucher.mode || VOUCHER_GENERATION_MODE.AUTO, [Validators.required]),
            code            : new FormControl(this.voucher.code, []),
            onetime         : new FormControl(this.voucher.onetime, []),
            start           : new FormControl(this.voucher.start, [Validators.required]),
            expiration      : new FormControl(this.voucher.expiration, [Validators.required]),
            products        : new FormControl(this.voucher.products),
            method          : new FormControl(this.voucher.method || VOUCHER_COMPUTE_MODE.NUMERAL, []),
            value           : new FormControl(this.voucher.value, [Validators.required, Validators.min(0)]),
            disabled         : new FormControl(this.voucher.disabled || false, []),
        });
    }

}



// WEBPACK FOOTER //
// /usr/app/src/app/main/content/app/vouchers/voucher-form/voucher-form.component.ts